/*
 * TODO: enable typscript
 * https://app.asana.com/0/1200062349227021/1199917794572413/f
 * import { Options } from './analytics.types'
 */
import api from '@/services/api'
import { toStartDate, toEndDate } from '@/helpers/date.js'

// TODO clean this up a bit so that way other audience analytics can use it
export const formatOptionsQuery = options => {
  let query = ''
  if (options.type) {
    query += `/${options.type}`
  }
  if (options.campaign) {
    query += `?campaign=${options.campaign}`
  } else if (options.episode) {
    query += `?episode=${options.episode}`
  } else if (options.podcast && options.podcast !== 'all') {
    query += `?podcast=${options.podcast}`
  } else if (options.network && options.network !== 'all') {
    query += `?network=${options.network}`
  } else if (options.account) {
    query += `?account=${options.account}`
  }
  if (options.episodes && options.episodes.length > 0) {
    query += `&episodes=${options.episodes.toString()}`
  }
  if (options.podcasts && options.podcasts.length > 0) {
    query += `&podcasts=${options.podcasts.toString()}`
  }
  if (options.networks && options.networks.length > 0) {
    query += `&networks=${options.networks.toString()}`
  }
  if (options.timeframe && !options.release) {
    if (options.timeframe.start) {
      query += `&start_date=${toStartDate(options.timeframe.start)}`
    }
    if (options.timeframe.end && options.timeframe.start) {
      query += `&end_date=${toEndDate(options.timeframe.end)}`
    } else if (options.timeframe.end) {
      query += `&end_date=${toStartDate(options.timeframe.end)}`
    }
  }
  if (options.sort) {
    query += `&sort=${options.sort}`
  }
  if (options.limit) {
    query += `&limit=${options.limit}`
  }
  if (options.offset) {
    query += `&offset=${options.offset}`
  }
  if (options.interval) {
    query += `&interval=${options.interval}`
  }
  if (options.segmentLength) {
    query += `&segment_length=${options.segmentLength}`
  }
  if (options.csv) {
    query += `&csv=${options.csv}`
  }
  if (options.email) {
    query += `&email=${options.email}`
  }
  if (options.release) {
    query += `&release=${options.release}`
  }
  if (options.accum && options.csv) {
    query += '&accum=true'
  }
  if (options.url_style) {
    query += `&url_style=${options.url_style}`
  }
  return query
}

export const getAnalyticsUrl = (path, options) =>
  `/analytics/${path}${formatOptionsQuery(options)}`

export const getCsvUrl = (path, options, csv) => getAnalyticsUrl(path, {
  ...options,
  csv
})

export const getEpisodesCsvUrl = options => getCsvUrl('episodes', options, true)
export const getDownloadsCsvUrl = options => getCsvUrl('downloads', options, true)
export const getTechnologyCsvUrl = options => getCsvUrl('technology', options, true)
export const getDMACsvUrl = options => getCsvUrl('dma', options, true)
export const getOverlapCsvUrl = options => getCsvUrl('overlap/comparison', options, true)
export const getNetworkSummaryDownloadUrl = options => getCsvUrl('comprehensive', options, false)

export const getAnalytics = (path, options) => {
  const apiUrl = getAnalyticsUrl(path, options)
  // TODO: remove this if block once we clean out all the places that use it
  // so the function returns a consistent type (Promise)
  if (options.csv === true || options.email === true) {
    // console.log('getAnalytics: returning a string instead of a promise')
    // console.log(apiUrl)
    return apiUrl
  }
  return api.get(apiUrl).then(({ data }) => data)
}
